// Chuyển tab popup Nhiệm vụ (getlist) — dùng event delegation nên hoạt động
// kể cả khi popup được render/hiện sau.
$(function () {
	$(document).on("click", ".popup_getlist .task-tab", function (e) {
		e.preventDefault();
		var $tab = $(this);
		var key = $tab.data("tab");
		var $popup = $tab.closest(".popup_getlist");

		$popup.find(".task-tab").removeClass("active");
		$tab.addClass("active");

		$popup.find(".task-panel").removeClass("active");
		$popup.find('.task-panel[data-panel="' + key + '"]').addClass("active");
	});
});

window.addEventListener("load", function () {
	if ($('body').data('device-type') === 'mobile') return;

	const $wrapper = $("#MS__wrapper");
	const $outer = $(".MS__outer");
	const $profileFrame = $("#nth-ld-t4-profile");
	const $loadingLayer = $(".MS__layer-loading");
	if (!$wrapper.length && !$outer.length) return;

	const toggleLoading = (isActive) => {
		if (!$loadingLayer.length) return;
		$loadingLayer.css("display", isActive ? "block" : "none");
	};

	const fitWrapperToViewport = () => {
		const isProfileVisible =
			$profileFrame.length && $profileFrame.css("display") !== "none";

		if (isProfileVisible) {
			
			return;
		}

		$("html, body").scrollTop(0);
		window.scrollTo(0, 0);

		const viewportW = window.innerWidth;
		const viewportH = window.innerHeight;
		const $baseTarget = $wrapper.length ? $wrapper : $outer;
		const baseEl = $baseTarget.get(0);

		const baseW = $baseTarget.outerWidth();
		const baseH = baseEl.scrollHeight || $baseTarget.outerHeight();
		if (!baseW || !baseH) return;

		// Keep content fully visible and remove vertical scrolling.
		const scaleByWidth = viewportW / baseW;
		const scaleByHeight = viewportH / baseH;
		const scale = Math.min(scaleByWidth, scaleByHeight);
		const offsetLeft = Math.max((viewportW - baseW * scale) / 2, 0);

		$wrapper.add($outer).css({
			transformOrigin: "left top",
			transform: `scale(${scale})`,
			marginLeft: `${offsetLeft}px`
		});

		$("html, body").css("overflow-y", "hidden");
	};

	$(window).on("resize orientationchange", fitWrapperToViewport);

	// Keep loading layer visible until first fit+paint is completed.
	toggleLoading(true);
	window.requestAnimationFrame(() => {
		fitWrapperToViewport();
		window.requestAnimationFrame(() => {
			toggleLoading(false);
		});
	});
});